export default () => ({
  root: {
    margin: '0 auto',
    padding: '2rem',
  },
});
